<template>
  <div id="join">
    <!-- 操作 -->
    <!-- <h3>我的案例</h3> -->
    <!-- <List :list="list" :loading="loading" /> -->
    <loading-overlay v-if="loading"></loading-overlay>
    <div class="search">
      <el-form ref="formMore" :model="formMore" label-width="90px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="服务律师">
              <el-input
                class="select"
                v-model.trim="formMore.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="顾问单位">
              <el-input
                class="select"
                v-model.trim="formMore.responseUnit"
                placeholder="请输入顾问单位"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="单位性质">
              <el-select
                clearable
                v-model.trim="formMore.UnitType"
                placeholder="请选择"
                class="select"
              >
                <el-option
                  v-for="item in unitTypes"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="当前状态">
              <el-select
                clearable
                v-model.trim="formMore.Status"
                placeholder="请选择"
                class="select"
              >
                <el-option
                  v-for="item in StatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-form-item label="申报时间">
              <el-date-picker
                class="select"
                v-model="formMore.PostTimeS"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col el-col :span="5">
            <el-form-item>
              <el-date-picker
                class="select"
                v-model="formMore.PostTimeE"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="开始时间">
              <el-date-picker
                class="select"
                v-model="formMore.StartTimeS"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col el-col :span="5">
            <el-form-item>
              <el-date-picker
                class="select"
                v-model="formMore.StartTimeE"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="search1()">搜索</el-button>

              <el-button @click="resFuntion">重置</el-button>
              <el-button
                type="primary"
                plain
                @click="Export()"
                v-if="$store.state.rolesname.includes('allCounsel_Export')"
                >导出</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column
        prop="applyName"
        label="服务律师"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="responseUnit"
        label="顾问单位"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="startTime"
        :formatter="formatTime"
        label="开始时间"
      ></el-table-column>
      <el-table-column
        prop="endTime"
        :formatter="formatTime"
        label="结束时间"
      ></el-table-column>
      <el-table-column prop="unitType" label="单位性质"></el-table-column>
      <el-table-column
        prop="sealStatus"
        label="用章申请"
        :formatter="formatSealStatus"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="顾问申请"
        :formatter="formatStatus"
      ></el-table-column>
      <el-table-column label="功能" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            size="small"
            @click="handleClick(scope.row)"
            v-if="allCounselDetail"
            >查看</el-button
          >
          <el-popconfirm
            style="margin: 0 5% 0 5%"
            title="是否确定删除该条数据？"
            @confirm="jqsClick(scope.row.id)"
            v-if="
              scope.row.status == 0 &&
              scope.row.status != -1 &&
              $store.state.rolesname.includes('allCounsel_delete')
            "
          >
            <el-button type="warning" size="small" slot="reference"
              >删除</el-button
            >
          </el-popconfirm>
          <!-- <el-popconfirm
            v-if="scope.row.status == 3 && CounselDelete"
            title="是否确定删除？"
            @onConfirm="changeStatus(scope.row, 9)"
            @confirm="changeStatus(scope.row, 9)"
            style="margin-left: 10px"
          >
            <el-button type="warning" plain size="small" slot="reference"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            type="danger"
            plain
            size="small"
            slot="reference"
            v-if="
              (scope.row.sealStatus == 9 || scope.row.sealStatus == 1) &&
              CounselApplySeal
            "
            style="margin-left: 10px"
            @click="applySeal(scope.row)"
            >申请用章</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes"
        :total="Total"
      ></el-pagination>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="Total"
      ></el-pagination>
    </div>

    <!-- 详情dialog -->
    <el-dialog
      :title="dialogFormTitle"
      :visible.sync="dialogFormVisible"
      width="60%"
      class="dialog"
      center=""
      @closed="closeForm('form')"
      
    >
      <el-form ref="form" :model="form" label-width="25%">
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务律师">
              <el-input
                v-model.trim="form.applyName"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顾问单位">
              <el-input
                v-model.trim="form.responseUnit"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="身份证号/社会信用代码/护照号" label-width="200px">
              <el-input
                v-model.trim="form.idnumber"
               style="width:86%"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位性质">
              <el-input
                v-model.trim="form.unitType"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前状态">
              <el-input
                v-model.trim="form.statusstr"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-input
                v-model.trim="form.startTime"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间">
              <el-input
                v-model.trim="form.endTime"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提交时间">
              <el-input
                v-model.trim="form.postTime"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期">
              <el-input
                v-model.trim="form.duration"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="顾问金额">
              <el-input
                v-model.trim="form.amount"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业类型">
              <el-input
                v-model.trim="form.unitType"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用章类型">
              <el-select
                v-model.trim="form.sealType"
                class="sel-input-all"
                :disabled="true"
                clearable
              >
                <el-option
                  v-for="item in sealTypes"
                  :key="item.sealtype"
                  :label="item.typename"
                  :value="item.sealtype"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属分所">
              <el-input
                v-model.trim="form.org"
                class="sel-input-all"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
         
          <el-col :span="12">
            <el-form-item
              label="附件"
              prop="file"
              v-if="Upload.FileList.length > 0"
            >
              <div v-for="item in Upload.FileList" :key="item.id" class="input">
                <div class="fj">
                  <div style="flex: 1">
                    <img
                      src="../../assets/file/word.svg"
                      class="img"
                      v-if="
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('doc')
                      "
                    />
                    <img
                      src="../../assets/file/xls.svg"
                      class="img"
                      v-if="
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('xls')
                      "
                    />
                    <img
                      src="../../assets/file/png.svg"
                      class="img"
                      v-if="
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('jpg') ||
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('jpeg') ||
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('png')
                      "
                    />
                    <img
                      src="../../assets/file/PDF.svg"
                      class="img"
                      v-if="
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('pdf')
                      "
                    />
                    <img
                      src="../../assets/file/txt.svg"
                      class="img"
                      v-if="
                        item.name
                          .substring(item.name.lastIndexOf('\.') + 1)
                          .toLocaleLowerCase()
                          .includes('txt')
                      "
                    />
                  </div>
                  <div class="fname" style="flex: 9">
                    <div>
                      {{ item.name }}
                    </div>
                    <div class="word">
                      <span
                        @click="prievewFileClick(item)"
                        class="look"
                        v-if="allCounselSee"
                        >预览</span
                      >
                      <span
                        class="down"
                        @click="downloadFileClick(item)"
                        v-if="allCounselDown"
                        >下载</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
      </el-form>
      <div class="top" v-if="conflictTable.length > 0">
        <!-- <div class="icon"></div> -->
        <div>
          冲突案件
          <span style="color: black; font-size: 14px; margin-left: 10px"
            >(<span style="color: blue">蓝色</span>为代理方,
            <span style="color: red; font-weight: 900">!</span
            >橙色代表冲突方,灰色背景是导入数据)</span
          >
        </div>
      </div>
      <div class="conflictTable" v-if="conflictTable.length > 0">
        <el-table
          :data="conflictTable"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          max-height="380px"
          class="ct_table"
          :row-class-name="tableRowClass"
        >
          <el-table-column prop="title" label="案件名称"> </el-table-column>
          <el-table-column prop="code" label="案件编号"> </el-table-column>
          <el-table-column prop="litigant" label="当事人">
            <template slot-scope="scope">
              <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
                {{ scope.row.litigant[0].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[0].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span
                    v-if="
                      scope.row.isClient == 1 && item.name == scope.row.name
                    "
                    style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[0].all.length - 1"
                    >,
                  </span>
                </span>
              </div>

              <div v-if="scope.row.litigant[1]" class="litigant-container">
                {{ scope.row.litigant[1].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[1].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span
                    v-if="
                      scope.row.isClient == 1 && item.name == scope.row.name
                    "
                    style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[1].all.length - 1"
                    >,
                  </span>
                </span>
              </div>
              <div v-if="scope.row.litigant[2]" class="litigant-container">
                {{ scope.row.litigant[2].attribute }}：
                <span
                  v-for="(item, index) in scope.row.litigant[2].all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span
                    v-if="
                      scope.row.isClient == 1 && item.name == scope.row.name
                    "
                    style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < scope.row.litigant[2].all.length - 1"
                    >,
                  </span>
                </span>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
          <!-- <el-table-column prop="litigant[0].all" label="参与方1">
            <template slot-scope="scope" v-if="scope.row.litigant[0]">
              <span
                v-for="(item, index) in scope.row.litigant[0].all"
                :key="item.id"
                style="display: inline"
              >
                <span
                  v-if="scope.row.isClient == 1 && item.name == scope.row.name"
                  style="color: red; font-weight: 900"
                  >!</span
                >
                <span :style="{ color: getRandomColor(item.isClient) }">{{
                  item.name
                }}</span>
                <span v-if="index < scope.row.litigant[0].all.length - 1"
                  >,
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="litigant[1].all" label="参与方2">
            <template slot-scope="scope" v-if="scope.row.litigant[1]">
              <span
                v-for="(item, index) in scope.row.litigant[1].all"
                :key="item.id"
                style="display: inline"
              >
                <span
                  v-if="scope.row.isClient == 1"
                  style="color: red; font-weight: 900"
                  >!</span
                >
                <span :style="{ color: getRandomColor(item.isClient) }">{{
                  item.name
                }}</span>
                <span v-if="index < scope.row.litigant[1].all.length - 1"
                  >,
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="litigant[2].all" label="参与方3">
            <template slot-scope="scope" v-if="scope.row.litigant[2]">
              <span
                v-for="(item, index) in scope.row.litigant[2].all"
                :key="item.id"
                style="display: inline"
              >
                <span
                  v-if="scope.row.isClient == 1"
                  style="color: red; font-weight: 900"
                  >!</span
                >
                <span :style="{ color: getRandomColor(item.isClient) }">{{
                  item.name
                }}</span>
                <span v-if="index < scope.row.litigant[2].all.length - 1"
                  >,
                </span>
              </span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                class="copy"
                @click="conflictClick(scope.row)"
                v-if="allCounselCase&&!scope.row.isOther"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div v-if="hasMore" style="text-align: center;">
          <el-button  type="text" @click="showAllCaseClick" >
            {{ showAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>

      </div>
      <div class="dialog-footer">
        <!-- <el-button
          type="primary"
          @click="approve(form, 1)"
          v-if="
            (form.status == '1' || form.status == '2') && legalCounselApprove
          "
          >通过</el-button
        >
        <el-button
          type="warning"
          @click="approve(form, 2)"
          v-if="(form.status == '1' || form.status == '2') && legalCounselBack"
          >驳回</el-button
        > -->
        <el-button class="history" @click="fanhui">返回</el-button>
      </div>
      <div class="top" v-if="conflictCounsel.length > 0">
        <!-- <div class="icon"></div> -->
        <div>
          冲突顾问<span style="color: black; font-size: 14px; margin-left: 10px">(<span
              style="color: red; font-weight: 900">!</span>橙色代表冲突,灰色背景是导入数据)</span>
        </div>
      </div>
      <div class="conflictTable" v-if="conflictCounsel.length > 0">
        <el-table :data="conflictCounsel" :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }" max-height="300" class="ct_table" :row-class-name="tableRowClass">
          <el-table-column prop="name" label="单位企业">
            <template slot-scope="scope">
              <div> <span style="color: red; font-weight: 900" v-if="scope.row.isshow">!</span>
                <span :style="{
                  color: getRandomColor1(scope.row.isshow)
                }">{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="idnumber" label="身份证号/社会信用代码/护照号">
            <template slot-scope="scope">
              {{ scope.row.idnumber }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" :formatter="formatTime"> </el-table-column>
          <el-table-column prop="endTime" label="结束时间" :formatter="formatTime"> </el-table-column>
          <el-table-column prop="memberId" label="服务律师">
            <template slot-scope="scope">
              {{ GetMebert(scope.row.memberId,scope.row.lawer) }}
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="log">
        <div class="Approvelog">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in logs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.content }}</div>

                <div class="time">
                  {{ handleTime(item.timestamp) }}
                </div>
              </div>
              <div style="color: #909399">{{ item.type }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="Approvelog" v-if="processlogs.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in processlogs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.type }}</div>

                <div class="time">
                  {{ item.timestamp }}
                </div>
              </div>
              <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="Approvelog" v-if="Process.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in Process"
              :key="index"
              :timestamp="item.type"
            >
              {{ item.name }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>
    <!-- 预览dialog -->
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>

    <!-- 用章申请dialog -->
    <el-dialog
      title="用章申请"
      :visible.sync="dialogSealVisible"
      width="40%"
      class="dialog"
      center=""
      :before-close="handleClose"
      @closed="closeForm('formSeal')"
    >
      <el-form
        ref="formSeal"
        :model="formSeal"
        label-width="20%"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="用印类型" label-width="100px" prop="sealType">
              <el-select
                v-model="formSeal.sealType"
                class="all-select"
                clearable
                collapse-tags
                placeholder="请选择"
                @change="getsealApprovers()"
              >
                <el-option
                  v-for="item in sealTypes"
                  :key="item.sealtype"
                  :label="item.typename"
                  :value="item.sealtype"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用印二次审批人"
              label-width="150px"
              prop="sealApprover"
            >
              <el-select
                v-model="formSeal.sealApprover"
                class="all-select"
                clearable
                filterable
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sealApprovers"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sealapply('formSeal')"
          >确定</el-button
        >
        <el-button class="history" @click="dialogSealVisible = false"
          >返回</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import {
  ChangeStatus,
  CounselDetail,
  requestDownLoadFile,
  DownLoadFile,
  requestReview,
  AdviceApprove,
  SealApply,
  GetSealApprovers,
  GetConflictCounsel,
  AllCounselList,
  ExportCounsel,
  IsConflict,
  GetMembers
} from '../../api/counsel.js'
import { CaseProcess, CaseApprover, CaseLog } from '../../api/bankrupt'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
import mammoth from 'mammoth'
export default {
  name: 'allCounsel',
  data() {
    var validateValue = (rule, value, callback) => {
      if (value === '' || value === null || value == undefined) {
        callback(new Error('请正确输入'))
      } else {
        callback()
      }
    }
    return {
      processlogs: [],
      Process: [],
      logs: [],
      CounseId: null,

      allCounselDetail: false,
      allCounselCase: false,
      CounselApplySeal: false,
      CounselDelete: false,
      legalCounselDetail: false,
      legalCounselBack: false,
      allCounselSee: false,
      allCounselDown: false,
      legalCounselApprove: false,
      list: [],
      loading: true,
      formMore: {
        name: '',
        responseUnit: '',
        PostTime: [],
        StartTime: [],
        UnitType: '',
        Status: ''
      },
      formSeal: {
        sealType: '',
        id: null,
        sealApprover: null
      },
      unitTypes: [
        { typeid: '个人', typename: '个人' },
        { typeid: '政府', typename: '政府' },
        { typeid: '部委办局', typename: '部委办局' },
        { typeid: '金融行业', typename: '金融行业' },
        { typeid: '大型国有企业', typename: '大型国有企业' },
        { typeid: '医院', typename: '医院' },
        { typeid: '教育机构', typename: '教育机构' },
        { typeid: '上市企业', typename: '上市企业' },
        { typeid: '民营企业', typename: '民营企业' },
        { typeid: '事业单位', typename: '事业单位' },
        { typeid: '外资企业', typename: '外资企业' },
        { typeid: '其他', typename: '其他' }
      ],
      StatusList: [
        { id: 0, name: '审核通过' },
        { id: 1, name: '部门管理人审批中' },
        { id: 2, name: '二次审批人审批中' },
        { id: 3, name: '审核未通过' },
        { id: 4, name: '已过期' },
        { id: 9, name: '已删除' }
      ],
      sealTypes: [
        { typename: '公章', sealtype: 'official_seal' },
        { typename: '法人章', sealtype: 'corporate_seal' },
        { typename: '合同章', sealtype: 'contract_seal' },
        { typename: '公章+法人章', sealtype: 'official_corporate_seal' },
        { typename: '合同章+法人章', sealtype: 'contract_corporate_seal' }
        // { typename:"律师函专用章",sealtype:"legal_letter_seal"},
      ],
      sealApprovers: [],
      sealType: '',
      isPage: true,
      more: '',
      typeList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      dialogFormVisible: false,
      dialogSealVisible: false,
      dialogFormTitle: '',
      form: {},
      Upload: {
        Dialog_Preview: false,
        Image_Preview: '',
        FileList: []
      },
      Total: 0,
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      conflictTable: [], //查看案件冲突列表
      rules: {
        sealType: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ],
        sealApprover: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ]
      },
      loading: true,

      conflictCounsel: [],
      conflictCounselShow: false,
      conflictCounselName:null,

      showAllCase:false,//是否显示全部冲突案件
      hasMore:false,
      allConflictCase:[],//所有的冲突案件
    }
  },
  created() {
    this.getmember()
    this.allCounselDetail =
      this.$store.state.rolesname.includes('allCounselDetail')
    this.allCounselCase = this.$store.state.rolesname.includes('allCounselCase')
    this.allCounselSee = this.$store.state.rolesname.includes('allCounselSee')
    this.allCounselDown = this.$store.state.rolesname.includes('allCounselDown')
    this.search()
    this.getLink()
  },
  mounted() {
    // console.log('form', this.form)
  },

  methods: {
    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    showAllCaseClick(){
      if(this.showAllCase){
        this.showAllCase=false
        this.conflictTable = this.allConflictCase.filter(item => item.isClient == 1)//所有有冲突的案件
        if(this.conflictTable.length==0){//没有冲突案件
          this.conflictTable.push(this.allConflictCase[0])
        } 
       
      }else{
        this.conflictTable=this.allConflictCase
        this.showAllCase=true
      }
    },
    // 获取律师
    getmember() {
      GetMembers()
        .then((res) => {
          if (res.data.status == 'success') {
            this.members = res.data.data.filter((item) => item.status == 0 || item.status == 6)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('获取律师出错')
        })
    },
    GetMebert(row,law){
      if(row==null||row==''){
        return law
      }
      var c=this.members.find(p=>p.value==row);
      if(c){
        return c.label
      }else{
        return ''
      }
    },
    GetCounselConflict(row) {
      IsConflict({
          customer: row.responseUnit,
          st: row.startTime,
          et: row.endTime,
          id:row.id,
          idnumber:row.idnumber
        }).then((res) => {
          if (res.data.status == 'success') {
            console.log(res.data.data)
            if (res.data.data == "N/A") {
              this.conflictCounsel = []
              this.conflictCounselShow = false
              this.conflictCounselName=null
            } else {
              this.conflictCounselName = JSON.parse(JSON.stringify(row.responseUnit)) 
              console.log(Array.isArray(res.data.data))
              if (Array.isArray(res.data.data)) {
                this.conflictCounsel = res.data.data
                this.conflictCounselShow = true
              } else {
                this.conflictCounsel = [res.data.data]
                this.conflictCounselShow = false
                console.log("1",this.conflictCounselName)
                // this.conflictCounselName=null
              }
            }
          } else {
            this.$message.error(res.data.message)
          }

          // this.$refs.child.search()
        })
          .catch((res) => {
            this.loading = false
            this.$message.error(res.data.message)
            return
          })

    },
    getRandomColor1(show) {
      if (show) return '#e86e30'
      else return 'blue'
    },
    jqsClick(id) {
      ChangeStatus({
        Id: id,
        status: 9,
        approvestatus: 9
      }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success('删除成功')
          this.search()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    // 重置
    resFuntion() {
      this.formMore.name = null
      this.formMore.responseUnit = null
      this.formMore.UnitType = ''
      this.formMore.Status = ''
      this.formMore.PostTimeS = ''
      this.formMore.PostTimeE = ''
      this.formMore.StartTimeS = ''
      this.formMore.StartTimeE = ''
      this.search1()
    },
    getUrlParams(url) {
      const params = {}
      const regex = /[?&]+([^=&]+)=([^&]*)/g
      let match

      while ((match = regex.exec(url))) {
        const key = decodeURIComponent(match[1])
        const value = decodeURIComponent(match[2])
        params[key] = value
      }

      if (params == {}) {
        return null
      } else {
        return params
      }
    },
    fanhui() {
      // if (this.$route.query.row !== undefined) {
      //   this.dialogFormVisible = false
      //   this.$router.go(-1)
      // } else {
      this.dialogFormVisible = false
      // }
    },

    async getLink() {
      // var row = this.$route.query

      var row = this.getUrlParams(window.location.href)
      // console.log('all-row', row)
      if (row !== undefined && row != null && JSON.stringify(row) !== '{}') {
        // console.log('进if')
        await GetConflictCounsel({
          name: row.companyName
        }).then((res) => {
          // debugger
          if (res.data.status == 'success') {
            this.hasMore=false
            this.showAllCase=false
            if (res.data.data.length > 0) {
              // this.conflictTable = res.data.data
              this.allConflictCase = res.data.data
              
                this.conflictTable = this.allConflictCase.filter(item => item.isClient == 1)//所有有冲突的案件
                // console.log("this.conflictTable",this.allConflictCase)
                if(this.conflictTable.length==0){//没有冲突案件
                  this.conflictTable.push(this.allConflictCase[0])
                } 
                if(this.allConflictCase.length>this.conflictTable.length&&this.allConflictCase.length>1){
                  this.hasMore=true
                }
            }
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        await CounselDetail({
          id: row.id
        }).then((res) => {
          if (res.data.status == 'success') {
            this.form = res.data.data[0]
            var atc = res.data.data
            if (atc != null && atc.length > 0) {
              if (res.data.data[0].attech.length > 0) {
                var attech = res.data.data[0].attech
                attech.forEach((item, index) => {
                  this.Upload.FileList.push({
                    name: item.name,
                    id: item.id
                  })
                })
              }
            }

            this.CounseId = row.id
            this.GetLog(row.id)
            if (res.data.data.length > 0) {
              this.Successlog(row.id)
              this.GetProcess(row.id, this.form.sealId)
            }
            this.dialogFormVisible = true
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },

    Export() {
      this.loading = true
      let Params = {
        name: this.formMore.name,
        responseUnit: this.formMore.responseUnit,
        // PostTime: this.formMore.PostTime,
        // StartTime: this.formMore.StartTime,
        PostTimeS:
          this.formMore.PostTimeS == '' ? null : this.formMore.PostTimeS,
        PostTimeE:
          this.formMore.PostTimeE == '' ? null : this.formMore.PostTimeE,
        StartTimeS:
          this.formMore.StartTimeS == '' ? null : this.formMore.StartTimeS,
        StartTimeE:
          this.formMore.StartTimeE == '' ? null : this.formMore.StartTimeE,

        UnitType: this.formMore.UnitType,
        Status: this.formMore.Status.toString(),
        rows: this.pageSize,
        page: this.currentPage
      }
      ExportCounsel(Params)
        .then((res) => {
          this.loading = false
          if (res.data.status == 'success') {
            this.$message.success('导出成功')
            this.handleExportExcel(res.data.data)
          } else {
            this.$message.error(res.data.message)
          }

          // this.
        })
        .catch(() => {
          this.loading = false
          this.$message.error('导出失败')
        })
    },
    handleExportExcel(base64String) {
      const link = document.createElement('a')
      link.href = 'data:application/octet-stream;base64,' + base64String
      link.download = 'export.xlsx' // 下载文件的名称
      link.click()
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    GetLog(id) {
      //获取日志
      CaseLog({ Id: id, type: 'adviser' }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
          if (this.logs.Reason) {
            this.logs.Reason = JSON.parse(this.logs.Reason).Reason
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    //获取审核日志
    Successlog(id) {
      // console.log(IdleDeadline)
      CaseApprover({ AdviserId: id }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetProcess(id, sId) {
      if (this.form.advisersstatus == 0 && sId != null) {
        CaseProcess({ SealId: sId }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      } else {
        CaseProcess({ AdviserId: id }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      }
    },
    search1() {
      this.currentPage = 1
      this.search()
    },
    close() {
      if (this.imgUrl) {
        this.imgUrl = ''
      }
    },
    search() {
      this.loading = true
      let Params = {
        name: this.formMore.name,
        responseUnit: this.formMore.responseUnit,
        // PostTime: this.formMore.PostTime,
        // StartTime: this.formMore.StartTime,
        PostTimeS:
          this.formMore.PostTimeS == '' ? null : this.formMore.PostTimeS,
        PostTimeE:
          this.formMore.PostTimeE == '' ? null : this.formMore.PostTimeE,
        StartTimeS:
          this.formMore.StartTimeS == '' ? null : this.formMore.StartTimeS,
        StartTimeE:
          this.formMore.StartTimeE == '' ? null : this.formMore.StartTimeE,

        UnitType: this.formMore.UnitType,
        Status: this.formMore.Status.toString(),
        rows: this.pageSize,
        page: this.currentPage
      }
      AllCounselList(Params)
        .then((res) => {
          this.loading = false
          if (res.data.status == 'success') {
            this.tableData = res.data.data
            this.Total = res.data.total
          } else {
            this.$message.error(res.data.message)
          }

          // this.
        })
        .catch(() => {
          this.loading = false
          this.$message.error('查询出错')
        })
    },
    approval() {},
    //下载文件
    async downloadFileClick(item) {
      this.loading = true
      // 获取服务器文件
      const res = await DownLoadFile({
        Id: item.id
      })
      if (res.status == '201') {
        this.loading = false
        this.$message.error('找不到文件')
        return
      }
      this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      // console.log(this.CounseId)
      this.GetLog(this.CounseId)
      this.loading = false
    },
    // 获取文件后缀
    getFileType(name) {
      if (name) {
        if (name.lastIndexOf('.') > -1) {
          return name.slice(name.lastIndexOf('.') + 1)
        } else {
          return false
        }
      }
    },
    // 预览文件
    prievewFileClick(item) {
      let fileType = this.getFileType(item.name)
      // 后台接口方法url：接口地址，data给后台传的参数
      // console.log('fileType', fileType)
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.id }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.id }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              // console.log('if')
              this.handlerError(res.data)
            } else {
              // console.log('else')
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    vm.vHtml = null
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.id }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = null
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
      } else {
        this.$message.error('不支持此文件预览')
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          } // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      fileReader.readAsText(data)
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null

      let fileType = this.getFileType(row.name)
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name)
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    // 案件冲突查看
    conflictClick(row) {
      this.$store.commit('setmenustatus', 1)
      var type=row.typeId.substring(21, 23)
      var url =
        '/#/home/case/caseinfo?guid=' +
        row.id +
        '&status=' +
        row.typeId +
        '&caseType=' +
        row.typeId.substring(21, 23)
      // // 在新窗口中打开页面
      if(type==12){
          url =
          '/#/home/case/bankruptdetail?guid=' +
          row.id +
          '&type=破产' 
        }
      let mywin = window.open(url, row.title)

      mywin.onload = function () {
        mywin.location.reload()
      }
      // this.$router.go(0)
    },
    //获取顾问的冲突案件
    async selectConfilct(row) {
      // debugger
      // console.log('row', row)
      await GetConflictCounsel({
        name: row.responseUnit,
        idnumber:row.idnumber
      }).then((res) => {
        // debugger
        if (res.data.status == 'success') {
          this.hasMore=false
            this.showAllCase=false
            if (res.data.data.length > 0) {
              // this.conflictTable = res.data.data
              this.allConflictCase = res.data.data
              
                this.conflictTable = this.allConflictCase.filter(item => item.isClient == 1)//所有有冲突的案件
                console.log("this.conflictTable",this.allConflictCase)
                if(this.conflictTable.length==0){//没有冲突案件
                  this.conflictTable.push(this.allConflictCase[0])
                } 
                if(this.allConflictCase.length>this.conflictTable.length&&this.allConflictCase.length>1){
                  this.hasMore=true
                }
            }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getFileFix(filename) {
      let fix = filename
        .substring(filename.lastIndexOf('.') + 1)
        .toLocaleLowerCase()
      return fix
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    changeStatus(row, status) {
      ChangeStatus({
        id: row.id,
        status: status
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$message.success('操作成功')
            this.dialogFormVisible = false
            this.search()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
    },
    approve(row, status) {
      AdviceApprove({
        id: row.id,
        status: row.status,
        approvestatus: status
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$message.success('操作成功')
            this.dialogFormVisible = false
            this.search()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
    },
    //详情
    async handleClick(row) {
      this.GetCounselConflict(row)
      await this.selectConfilct(row)
      CounselDetail({
        id: row.id
      })
        .then((res) => {
          if (res.data.status == 'success') {
            var returnData = res.data.data
            this.form = res.data.data[0]
            if (res.data.data[0].attech.length > 0) {
              var attech = res.data.data[0].attech
              attech.forEach((item, index) => {
                this.Upload.FileList.push({
                  name: item.name,
                  id: item.id
                })
              })
            }
            this.CounseId = row.id
            this.GetLog(row.id)
            if (returnData.length > 0) {
              this.Successlog(row.id)
              this.GetProcess(row.id, this.form.sealId)
            }
            this.dialogFormVisible = true
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$message.error('获取详情失败')
        })
    },
    //申请用章dialog
    applySeal(row) {
      this.dialogSealVisible = true
      this.formSeal.id = row.id
    },
    //获取用章二次审批人
    getsealApprovers() {
      this.formSeal.sealApprover = null
      GetSealApprovers({
        id: this.formSeal.id, //顾问申请id
        type: this.formSeal.sealType
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.sealApprovers = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('获取二次审批人出错')
        })
    },
    //申请用章
    sealapply(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          SealApply({
            id: this.formSeal.id,
            sealApprover: this.formSeal.sealApprover,
            sealType: this.formSeal.sealType
          })
            .then((res) => {
              this.loading = false
              if (res.data.status == 'success') {
                this.$message.success('已提交用章申请')
                this.dialogSealVisible = false
                this.search()
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(() => {
              this.loading = false
              this.$message.error('提交出错')
            })
        } else {
          this.$message.warning('请填入必填项')
          this.dialogsealVisible = true
          return false
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.dialogSealVisible = false
    },
    // 关闭dialog时清空表单
    closeForm(formName) {
      this.$refs[formName].resetFields()
      this.Upload.FileList = []
      this.conflictTable = []
      this.conflictCounsel = []
      this.conflictCounselShow = false
      this.conflictCounselName=null
      // this.formSeal = {};
    },
    formatTime(row, column) {
      if (row[column.property] == null) {
        return null
      }
      const date = new Date(row[column.property])
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year + '-' + month + '-' + day
        // day +
        // ' ' +
        // hours +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
    },
    formatStatus(row, column) {
      if (row[column.property] == 0) return '审核通过'
      else if (row[column.property] == 1) return '部门管理人审批中'
      else if (row[column.property] == 2) return '二次审批人审批中'
      else if (row[column.property] == 3) return '审核未通过'
      else if (row[column.property] == 4) return '已过期'
      else if (row[column.property] == 9) return '已删除'
      else return ''
    },
    formatSealStatus(row, column) {
      if (row[column.property] == -1) return '流程中'
      else if (row[column.property] == -2) return '已撤销'
      else if (row[column.property] == 9) return '没有用章'
      else if (row.status == 1 || row.status == 2) return '流程中'
      else if (row.status == 4) return '顾问已过期'
      else if (row[column.property] == 1) return '退回'
      else if (row[column.property] == 0) return '通过'
      else return ''
    },
    tableRowClass({ row, rowIndex }){
      console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    },
  }
}
</script>

<style lang="less" scoped>
#join {
  // position: relative;
  .search {
    box-sizing: border-box;
    width: 100%;
    // margin: auto;
    // display: flex;

    padding: 20px;
    // margin-bottom: 24px;
    // .el-input {
    //   width: 20%;
    // }
    ::v-deep .el-input__inner {
      // width: 80% !important;
      // width: 300px;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }
    // .el-select {
    //   margin: 0 10px;
    //   width: 150px;
    // }
  }
  .pagination {
    // position: absolute;
    // bottom: 40px;
    // right: 80px;
    margin: 20px 20px;
    // float: right;
    display: flex;
    justify-content: space-between;
    .el-pagination {
      padding-right: 50px;
    }
  }
  .sel-input-all {
    width: 70%;
  }
  .fj {
    // display: inline-flex;
    display: flex;
    align-items: center;
    background: #f5f7fa;
    justify-content: flex-start;
    padding: 10px;
    padding-right: 20px;
    margin-bottom: 10px;
  }
  .input {
    width: 75%;
  }
  .img {
    width: 100%;
  }
  .word {
    line-height: 18px;
    cursor: default;
  }
  .look {
    color: #fe964a;
  }
  .down {
    color: #2bc887;
    margin-left: 10px;
  }
  .dialog-footer {
    width: 100%;
    margin: auto;
    text-align: center;
    margin-top: 13px;
  }
  // .select {
  //   width: 10vw;
  //   margin-bottom: 1rem;
  // }
  .btn {
    width: 100%;
    text-align: center;
  }
  .top {
    width: 100%;
    display: flex;
    color: #3077e6;
    align-items: center;
    font-size: 1.1875rem;
    font-weight: 400;
    padding-left: 3.625rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  .icon {
    width: 0.25rem;
    height: 1.125rem;
    background: #3077e6;
    border-radius: 0.5625rem;
    margin-right: 0.3125rem;
  }
  .conflictTable {
    width: 100%;
  }
  .ct_table {
    width: 95%;
    margin-left: 2%;
  }
  .copy {
    color: #3077e6;
    border: none;
  }
}
.Approvelog {
  width: 80%;
  margin: auto;
  margin-top: 3rem;
}
/deep/.beig-row{
      background: #e6e5e4 !important;
  }
</style>
